import { render, staticRenderFns } from "./storeCollectList.vue?vue&type=template&id=119916a2&scoped=true"
import script from "./storeCollectList.vue?vue&type=script&lang=ts"
export * from "./storeCollectList.vue?vue&type=script&lang=ts"
import style0 from "./storeCollectList.vue?vue&type=style&index=0&id=119916a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119916a2",
  null
  
)

export default component.exports